import "./KeyMetricsSkeleton.scss";

const KeyMetricsSkeleton: React.FC = () => {
  return (
    <>
      {/* Skeleton Loaders */}
      <div className="metric-card skeleton">
        <div className="skeleton-label"></div>
        <div className="skeleton-value"></div>
      </div>
      <div className="metric-card skeleton">
        <div className="skeleton-label"></div>
        <div className="skeleton-value"></div>
      </div>
      <div className="metric-card skeleton">
        <div className="skeleton-label"></div>
        <div className="skeleton-value"></div>
      </div>
      <div className="metric-card skeleton">
        <div className="skeleton-label"></div>
        <div className="skeleton-value"></div>
      </div>
    </>
  );
};

export default KeyMetricsSkeleton;
